import { useEffect, useState } from 'react';
import axiosInstant from '../../api';
import { pricingPlanCatalogEndpoint } from '../../api/endpoints';
import type { PlansResponse } from '../../types/pricingPlans';

// Plan catalog for the internal /pricing comparison page (bearer sent by
// the axios singleton; the API gates it to internal roles).
export function usePlanCatalog() {
  const [data, setData] = useState<PlansResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    axiosInstant
      .get(pricingPlanCatalogEndpoint)
      .then((res) => {
        if (!mounted) return;
        const plans = [...((res.data && res.data.plans) || [])].sort(
          (a, b) => a.sort_order - b.sort_order,
        );
        setData({
          plans,
          featureRows: (res.data && res.data.featureRows) || [],
          collapsedGroups: (res.data && res.data.collapsedGroups) || [],
          production: (res.data && res.data.production) || undefined,
        });
        setError(null);
      })
      .catch(() => {
        if (mounted) setError('Pricing is unavailable right now.');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading, error };
}
